import React, { useState } from 'react';
import Sections from '../resources/Sections.json'
import chances from '../resources/chances.json'
import library from '../resources/library.json'
const DocsLayout = ({children}) => {
    return (
        <div className='w-auto  py-12 mx-auto space-y-12 px-4'>
            {children}
        </div>
    )
}
const Info = ({ img, headerText, text }) => {
  return (
    <div style={{'whiteSpace':"pre-line"}} className="relative flex max-lg:flex-reverse p-5  max-lg:flex-wrap lg:justify-evenly max-lg:justify-center  ">
      {/* Text Content */}
      <div dir='rtl' className="flex sm:order-1 flex-col space-y-4 text-right w-[70vh] max-lg:w-[100vh] h-auto sm:text-right">
        <h1 className="text-3xl max-md:text-xl text-start font-bold">{headerText}</h1>
        <p className="text-gray-200 max-md:text-[14px] leading-relaxed sm:max-w-full">{text}</p>
      </div>

      {/* Image */}
      <div className="flex  sticky  h-64 max-md:w-[100%]  h-full sm:justify-end">
        {img ? (
        <img
          src={img}
          alt={headerText}
          className=" max-lg:mx-auto max-md:w-[250px] max-md:h-[250px] w-[339px] h-[307px] rounded shadow-md "
        />):null
        }
      </div>
    </div>
  );
};
const Card = ({item}) => {
  return (
    <div  className='flex gap-3 flex-col justify-between py-5 bg-[#1B1B1B] h-[337px] w-auto h-auto w-[500px] p-2 px-4 rounded'>
      <div className='flex gap-2 flex-col'>
        <h1 dir='rtl' className='text-[20px] max-md:text-[16px] text-start'>{item['name']}</h1>
        <p dir='rtl' className='text-[20px] max-md:text-[14px]'>{item['summary']}</p>
        <p className='text-start text-[20px] max-md:text-[14px]'>Deadline: {item['DEADLINE']}</p>
        <p className='text-start text-[20px] max-md:text-[14px]'>Age: {item['age']}</p>
      </div>
        {item['LINK'] === 'Not Available' ?   <button className='text-[18px] bg-[#3555C6] rounded flex justify-center items-center w-[140px] h-[40px]'>Not Available</button>  : <a className='text-[18px] bg-[#3555C6] rounded flex justify-center items-center w-[140px] h-[40px]' href={item['LINK']}>More Info</a>}
    </div>
  )
}

const ProgramsSection = () => {
  const [filter,setfilter] = useState("")
    return (  <div style={{'whiteSpace':"pre-line"}} className='w-full'>
        <div className='text-3xl max-md:text-2xl flex flex-col justify-center  mx-auto w-full'>
          <h1 className='text-start mt-12'>Programs and Competitions:</h1>
          <div className='flex justify-between items-center mt-5'>
            <input onChange={(e) => {setfilter(e.target.value)}} type="text" placeholder="Search..." className="    w-full sm:w-80 bg-black text-white border border-gray-700 rounded-2xl px-4 py-2 placeholder-gray-400 focus:outline-none focus:border-gray-700" />
          </div>
          <div className='grid mt-10 lg:grid-cols-2 grid-cols-1 gap-[52px]'>
          {chances.filter(item => item.name.toLowerCase().includes(filter.toLowerCase())).map((item,i) => (
            <Card key={i} item={item}/>
          ))}
          </div>
        </div>
      </div>)
}
const LibraryCard = ({item,onclick}) => {
  return (
    <div  className='flex cursor-pointer gap-3 flex-col justify-between py-5 bg-[#1B1B1B] h-[337px] w-auto h-auto w-[500px] p-2 px-4 rounded' onClick={onclick}>
      <img src={item['image']} alt="first" className='h-64 w-64 m-auto ' />
      <div className='flex gap-2 flex-col'>
        <div className='flex flex-row-reverse'>
          <div className='bg-blue-500 text-[16px] flex justify-center items-center rounded-md w-[128px] h-[36px]'>{item['type']}</div>
          <div className='ml-5 text-[16px] text-[#A0A0A0]'>{item['date']}</div>
        </div>
        <h1 dir='rtl' className='text-[20px] max-md:text-[16px] text-start'>{item['header']}</h1>
        <p dir='rtl' className='text-[20px] max-md:text-[14px]'>{item['summary']}</p>
      </div>
    </div>
  )
}

const LibrarySection = () => {
    const [selectedItem,setSelectedItem] = useState(null)
    return (  <div style={{'whiteSpace':"pre-line"}} className='w-full'>
        <div className='text-3xl max-md:text-2xl flex flex-col justify-center  mx-auto w-full'>
          <div dir='rtl' className='grid grid-column-reverse mt-10 lg:grid-cols-2 grid-cols-1 gap-[52px]'>
            {library.map(
              (item,i) => (
                <LibraryCard onclick={() => setSelectedItem(item)} key={i} item={item}/>
              )
            )}
          </div>
        </div>
        {selectedItem && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setSelectedItem(null)}
          />
          <div className="relative bg-[#1B1B1B] w-[90%] h-[90%] rounded-2xl shadow-2xl p-8 overflow-y-auto">
            
            <button
              className="absolute top-4 right-4 text-xl"
              onClick={() => setSelectedItem(null)}
            >
              ✕
            </button>
            <img className='w-full object-contain h-[400px]' src={selectedItem.image} alt="" />
            <div>
              <h2 dir='ltr' className="text-3xl md:px-[60px] mt-4 font-bold mb-4">
                {selectedItem.header}
              </h2>

              <p dir='rtl' className="md:px-[60px] text-xlStext-base">
                {selectedItem.article}
              </p>
            </div>
          </div>
        </div>
      )}
      </div>)
}

const DocsHeader = ({Section_header,Section_paragraph,center,activesection}) => {
  const header = Section_header.split(" ").slice(0,-1).join(" ");
  const lastWord = Section_header.split(" ").slice(-1).join(" ");
  return (
    <>
    {activesection !== 'programs' && (
    <DocsLayout>
    <div dir='rtl' style={{whiteSpace: "pre-line"}} className='mx-auto max-md:w-[100%] w-[50%] mb-12 gap-12 h-[300px] flex flex-col justify-center items-center'>
      <h1 className='text-4xl text-white text-center'>{header} <span className='text-[#3555C6]'>{lastWord}</span></h1>
      <p className={`${center === 'center'? 'text-center' : 'text-start'} max-md:text-[14px]`}>{Section_paragraph}</p>
    </div>
    </DocsLayout>
  )}
    </>
  );
}

function Docs(props) {
    return (
        <div className={`min-w-screen overflow-y-hidden max-md:w-screen text-end ${props.activesection === 'programs' || props.activesection === 'library' ? 'bg-[#0D0D0D]' : ''}  text-[#E0E0E0]`}>
            <DocsLayout>
              {props.activesection !== 'library' && (
              <DocsHeader activesection={props.activesection} center={Sections.find(center => center.activesection === props.activesection)?.align} Section_header={props.activesection} Section_paragraph={Sections.find(item => item.activesection === props.activesection)?.text} />
              )
              }
                {Sections
                  .filter(item => item.type === props.activesection) // ✅ use item.type
                  .map((item, i) => ( // ✅ add i here
                    <Info
                      key={i}
                      headerText={item.header}
                      text={item.text}
                      img={item.image}
                    />
                  ))
                }
                {
                  props.activesection === 'programs' && (
                    <ProgramsSection/>
                  )
                }
                {
                  props.activesection === 'library' && (
                    <LibrarySection/>
                  )
                }
            </DocsLayout>
        </div>
    );
}

export default Docs;